import { IResponse, IServerError } from "@websential/cosmic-v20";
import http from "../../common/http-commons";
import { AxiosError, AxiosResponse } from "axios";

export const CountryService = {
	get: () => {
		return [
			{ value: "CAN", label: "Canada" },
			{ value: "USA", label: "United States of America" },
		];
	},
	getProvinceOrStateDDL: async (
		navigateToLogout: (path: string) => void,
		countryId: string,
		countryTag: string
	): Promise<any | IServerError | IResponse | null | any> => {
		if (countryTag === "Province" || countryTag === "province") {
			try {
				const response: AxiosResponse<any> = await http.get<any>(
					`/v1/Province/ddl?country_id=${countryId}`
				);

				if (response.status === 200) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}

				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		} else if (countryTag === "State" || countryTag === "state") {
			try {
				const response: AxiosResponse<any> = await http.get<any>(
					`/v1/states/ddl?country_id=${countryId}`
				);

				if (response.status === 200) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}

				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
	},
	getCountryDDL: async (): Promise<
		any | IServerError | IResponse | null | any
	> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/country/ddl`
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 404) {
				return [];
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 404) {
				return [];
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	archiveCountry: async (
		archivePayload: any
	): Promise<string | IServerError | IResponse | any> => {
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/country/${archivePayload.countryId}/`
			);

			if (response.status === 201) {
				return "Country has been archived successfully";
			} else if (response.status === 200) {
				return "Country has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
